import('./progress_bar.css')

export default function ProgressBar(opts = {}){
    let mapComponent = opts.mapComponent
    let overlay = opts.overlay
    let showCount = opts.showCount
    let container
    let elements = {}

    let count = {current:0, total: 'TODOS'}

    this.show = boolean =>{
        $(elements.container).toggleClass('show', boolean)
    }

    this.updateTotal = (current, total) =>{
        count.current = current > total ? total : current
        count.total = total || count.total
        if(count.total > 0){
            $(elements.progressBarFront).css({
                width: `${(count.current * 100 / count.total) > 100 ? 100 : (count.current * 100 / count.total)}%`
            })
        }
        

        $(elements.countContainer).html(`${count.current}/${count.total}`)
    }

    init.call(this)

    function init(){
        container = `${mapComponent._container} .map-container`
        elements.container = createElement('div', 'map-progress-bar-container')
        elements.progressBarWrapper = createElement('div', 'map-progress-bar-wrapper')
        addTitle()
        addBars()

        if(showCount){
            addCount.call(this)
        }

        if(overlay){
            addOverlay()
        }


        $(elements.container).append(elements.progressBarWrapper)
        $(container).append(elements.container)
    }

    function addBars(){
        elements.progressBarFront = createElement('div', 'map-progress-bar-front')
        elements.progressBarBack = createElement('div', 'map-progress-bar-back')
        elements.progressBar = createElement('div', 'map-progress-bar')
        $(elements.progressBar).append(elements.progressBarBack, elements.progressBarFront)
        $(elements.progressBarWrapper).append(elements.progressBar)
    }

    function addCount(){
        elements.countContainer = createElement('div', 'map-progress-bar-count-container')
        this.updateTotal(0, 100)
        $(elements.progressBarWrapper).append(elements.countContainer)
    }

    function addTitle(){
        elements.progressBarTitle = createElement('div', 'map-progress-bar-title')
        $(elements.progressBarTitle).html(opts.title)
        $(elements.progressBarWrapper).append(elements.progressBarTitle)
    }

    function addOverlay(){
        elements.overlay = createElement('div', 'progress-bar-overlay')
        $(elements.container).append(elements.overlay)
    }

    function createElement(type,classList){
        let el = document.createElement(type)
        if(classList){
            $(el).addClass(classList)
        }
        return el
    }
}